// ============================================================================
// ChatInfoAvatar — аватар чата в шапке панели «О чате».
//   • личный диалог — фото собеседника (avatar_url = id файла → UserAvatar:
//     скачивание через SSoT avatarStore, кэш в памяти);
//   • группа/обсуждение — первый символ названия, пустое название — иконка.
// Нет аватара/файл недоступен — UserAvatar сам показывает цветной круг с
// инициалами (как в списке чатов).
// ============================================================================

import { MessageSquare, Users } from 'lucide-react';
import { UserAvatar } from '@/components/ui/UserAvatar';

interface ChatInfoAvatarUser {
  id: string;
  name?: string;
  avatarUrl?: string;
}

interface ChatInfoAvatarProps {
  title: string;
  /** Групповой чат/обсуждение объекта — показываем название, не фото. */
  isGroup: boolean;
  /** Собеседник личного диалога (id сущности). */
  otherId?: string;
  users: ChatInfoAvatarUser[];
  size?: number;
}

export function ChatInfoAvatar({ title, isGroup, otherId, users, size = 32 }: ChatInfoAvatarProps) {
  if (!isGroup && otherId) {
    const user = users.find((u) => u.id === otherId);
    return <UserAvatar uid={otherId} fileId={user?.avatarUrl} name={user?.name || title} size={size} />;
  }

  const initial = title.trim().slice(0, 1).toUpperCase();
  return (
    <span
      className="flex shrink-0 items-center justify-center overflow-hidden rounded-full border border-primary/25 bg-primary/10 font-bold text-primary"
      style={{ width: size, height: size, fontSize: Math.max(11, Math.round(size * 0.42)) }}
      title={title}
    >
      {initial || (isGroup ? <Users className="h-4 w-4" /> : <MessageSquare className="h-4 w-4" />)}
    </span>
  );
}
